import React, { useState, useEffect } from 'react';
// import BottomNavigationVendor from "../BottomNavigationVendor/BottomNavigationVendor"
import BottomNavigationVendor from '../../../../Component/Vendors/BottomNavigationVendor/BottomNavigationVendor';
import axios from 'axios';
import { useNavigate } from "react-router-dom"
import CraneAcceptedOrders from './CraneAcceptedOrders';
import CraneRejectedOrder from './CraneRejectedOrder';
import CraneCompletedOrders from './CraneCompletedOrders';
import { useWebSocket } from '../../../../context/WebSocketContext';
import { ArrowLeft } from 'lucide-react';

const CraneOrders = () => {

    const navigate = useNavigate()
    const { messages } = useWebSocket()
    const [totalAssignedCases, setTotalAssignedCases] = useState([]);
    const [doneFetching, setDoneFetching] = useState(false);

    const [approvedCaseByYou, setApprovedCaseByYou] = useState([])
    const [rejectedByYou, setRejectedByYou] = useState([])
    const [rejectedByAdmin, setRejectedByAdmin] = useState([])
    const [rejectedByCustomer, setRejectedByCustomer] = useState([])
    const [completedVehicle, setCompletedVehicle] = useState([])
    const [recentlyCancelled, setRecentlyCancelled] = useState('')

    console.log("compltedVehicler", completedVehicle)


    const [gotResponse, setGotResponse] = useState([]);
    const [distance, setDistances] = useState([])

    const [caseDetails, setCaseDetails] = useState(false);

    const [avg, setAvg] = useState([])
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        if (messages.length > 0) {
            console.log('inside useEffect')
            messages.forEach((message) => {
                console.log("message123 craneorders", message.message);
                if (message.forPage === "crane-user-all-cases") {
                    fetchAssignedCases(0);
                }
            });
        } 
        if (token === '' || userId === '') {
            navigate('/');
        } 
        
        if ((token !== null && userId !== null)) {
            console.log('fetching deatils')
            fetchAssignedCases(0);
        }

    }, [token, userId, navigate, messages]);
    

    const choosenCase = (item) => {
        setApprovedCaseByYou([])
        setApprovedCaseByYou([item])
        setCaseDetails(true)
    }







    const fetchAssignedCases = async (typeOfIndex) => {
        try {
            let typeOfDetail = 'working';
            if(typeOfIndex == 1) typeOfDetail='rejected';
            else if(typeOfIndex == 2) typeOfDetail='completed';


            // let apiDetail = userId.startsWith('VC-') ? 'assignedTasksCraneForVendor' : 'assignedTasksUnfiltered';

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/assignedTasksUnfiltered/${userId}/${userId}/${typeOfDetail}`, { headers: { Authorization: `Bearer ${token}` } });
            console.log("Total assignedTasksMechanic", response.data.data);
            setTotalAssignedCases(response.data.data);

            const tempApprovedCaseByYou = [];
            const tempRejectedByYou = [];
            const tempRejectedByCustomer = [];
            const tempCompletedVehicle = [];
            console.log('response.data.data', response.data.data)
            response.data.data.forEach((item) => {
                if (item.details.length > 0) {

                    if (item?.details[0]?.completeOrder === 0 && item.details[0]?.firstResponseOn != null && item.details[0]?.vendorDecision === 'accept' &&
                        item.details[0]?.cancelOrder === 0 && item.details[0]?.cancelPreAssignOrder === 0 && item.details[0]?.closeWorker === 0) {
                        tempApprovedCaseByYou.push(item);
                    }
                    if (item.details[0]?.vendorDecision === 'reject') {
                        tempRejectedByYou.push(item);
                    }
                    if (
                        item.details[0].completeOrder === 0 && item.details[0]?.firstResponseOn != null && item.details[0]?.vendorDecision === 'accept' &&
                        (item.details[0]?.cancelPreAssignOrder || item.details[0]?.cancelOrder)
                    ) {
                        tempRejectedByCustomer.push(item);
                    }

                    if (item.details[0]?.approvedReaching === 1 && item.details[0].completeOrder === 1) {
                        tempCompletedVehicle.push(item);
                    }
                }
            }); 

            console.log("tempApprovedCaseByYou", tempApprovedCaseByYou)
            console.log("tempRejectedByYou", tempRejectedByYou)
            console.log("tempRejectedByCustomer", tempRejectedByCustomer)
            console.log("tempCompletedVehicl1e", tempCompletedVehicle)
            tempRejectedByCustomer.map(item=>{
                console.log('item.cancelledAt',item.details[0].cancelledAt)
                const cancellationTime = new Date(item.details[0].cancelledAt);
                console.log('cancellationTime', cancellationTime)
                const currentTime = new Date();
                console.log('currentTime', currentTime)

               const timeDiff = (currentTime - cancellationTime)/(1000*60);
               console.log('timediff', timeDiff)
                if(timeDiff < 2){
                    console.log('details[0].issue_occured',item.details[0].issue_occured)
                    setRecentlyCancelled(item.details[0].issue_occured);
                }
                
        })

            // Update state with collected results
            setApprovedCaseByYou(tempApprovedCaseByYou);
            setRejectedByYou(tempRejectedByYou);
            // setRejectedByAdmin(tempRejectedByAdmin);
            setRejectedByCustomer(tempRejectedByCustomer);
            setCompletedVehicle(tempCompletedVehicle);
            setDoneFetching(true);
        } catch (error) {
            console.error("Failed to fetch assigned cases:", error);
        }
    };





    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedRejectedIndex, setSelectedRejectedIndex] = useState(0);

    const handleSelect = (index) => {
        setSelectedIndex(index);
        fetchAssignedCases(index)
    };
    const handleSelectRejectedIndex = (index) => {
        setSelectedRejectedIndex(index)
    }
    return (
        <div>
              <div 
            //   onClick={()=>navigate(-1)} 
      className=" top-2 left-2 text-black rounded-full p-2 shadow-md cursor-pointer">
                          <ArrowLeft onClick={() => navigate(-1)}/>
                          </div>
            <div className="font-satoshi start-container" style={{ height: "7vh", zIndex: "10", margin: "0px 0px 0px 0px", position: "sticky", top: "0.1px", background:"white" }}>
            <div className="imageContainer mt-1 flex">
  {["Working cases", "Rejected cases", "Completed cases"].map((text, index) => (
   <div
  key={index}
  onClick={() => handleSelect(index)}
  className={`cursor-pointer imageWrapper transition-transform duration-300 ease-in-out ${
    selectedIndex === index ? "scale-105" : "hover:scale-100"
  }`}
>
  <div
    style={{
      boxShadow: 'inset -1px 0px 4px rgba(0, 0, 0, 0.1)',
    }}
    className={` px-[3vw] py-2 rounded-2xl text-sm font-medium border 
      ${
        selectedIndex === index
          ? "bg-[#21a6e9] text-white shadow-lg border-transparent"
          : "bg-gray-100 text-gray-800 hover:bg-indigo-100 border-gray-300"
      }`}
  >
    <p className="truncate">{text}</p>
  </div>
</div>

  ))}
</div>


            </div>

{doneFetching ? (<div>

            {selectedIndex === 1 && (
                <div className='bg-white'>
                <div className="imageContainer" style={{ height: "20px"  }}>
                    {["By You", 'By Customer'].map((text, index) => (
                        <div
                            key={index}
                            style={{ cursor: 'pointer', marginTop: "10px" }}
                            className={`imageWrapper ${selectedRejectedIndex === index ? "selected" : ""}`}
                            onClick={() => handleSelectRejectedIndex(index)}
                        >
                            <div className="top-scrolling">
                                <p>{text}</p>
                            </div>
                        </div>
                    ))}
                </div>
                </div>
            )}

            {selectedIndex === 0 && (
                <CraneAcceptedOrders data={approvedCaseByYou} recentlyCancelled={recentlyCancelled} />
            )}

            {selectedIndex === 2 && (
                <CraneCompletedOrders data={completedVehicle} />
            )}

            {selectedIndex === 1 && selectedRejectedIndex === 0 && (
                <CraneRejectedOrder data={rejectedByYou} />
            )}
            {selectedIndex === 1 && selectedRejectedIndex === 1 && (
                <CraneRejectedOrder data={rejectedByCustomer} />
            )}
            {selectedIndex === 1 && selectedRejectedIndex === 1 && (
                <CraneRejectedOrder data={rejectedByAdmin} />
            )}
</div>):(
    <div className='h-[100vh] flex justify-center items-center bg-white'>
     <div className="loader2 h-[6vh] w-[15px]"></div>
    </div>
)}


        </div>



    )
}


export default CraneOrders










































